/**
 * UI Components public API.
 * Import from here, never from individual files.
 *
 *   import { Button, Card, Ring, Bar } from '@/shared/ui';
 */

export { Button } from './Button';
export type { ButtonProps, ButtonVariant, ButtonSize } from './Button';

export { Card } from './Card';
export type { CardProps } from './Card';

export { Ring } from './Ring';
export type { RingProps } from './Ring';

export { Bar } from './Bar';
export type { BarProps } from './Bar';

export { Modal } from './Modal';
export type { ModalProps } from './Modal';

export { NumInput } from './NumInput';
export type { NumInputProps } from './NumInput';

// Zahleneingaben aus Textfeldern (Komma als Dezimaltrennzeichen).
export { parseNumericInput, parseNumericInputOr } from './parseNumber';

export { TextInput } from './TextInput';
export type { TextInputProps } from './TextInput';

export { Label } from './Label';
export type { LabelProps } from './Label';

export { ProgressDots } from './ProgressDots';
export type { ProgressDotsProps } from './ProgressDots';

export { ToastProvider, useToast } from './Toast';
export type { ToastProviderProps, ToastVariant } from './Toast';

export { SplashScreen } from './SplashScreen';
export type { SplashScreenProps } from './SplashScreen';

export { SectionHeader } from './SectionHeader';
export type { SectionHeaderProps } from './SectionHeader';

export { BackHeader } from './BackHeader';
export type { BackHeaderProps } from './BackHeader';

export { Icon } from './icons/Icon';
export type { IconName, IconProps } from './icons/Icon';

export { AthlynLogo } from './AthlynLogo';
export type { AthlynLogoProps } from './AthlynLogo';

export { EmptyState } from './EmptyState';
export type { EmptyStateProps } from './EmptyState';

// ── Redesign primitives (2026-07) — shared idioms from the Claude Design
// language: tabular numbers, standard list rows, iOS toggle. ──
export { Metric } from './Metric';
export type { MetricProps } from './Metric';

export { Row } from './Row';
export type { RowProps } from './Row';

export { Switch } from './Switch';
export type { SwitchProps } from './Switch';
